/** Captures the onboarding portal's magic-link token out of the URL *before* any analytics can see it. */

const ACCESS_PARAM = "access";
const PORTAL_PATH_PREFIX = "/setup/";

let capturedToken: string | null = null;

/** Read + strip the token. Safe to call more than once; only the first call captures. */
export function captureAndStripAccessToken(): void {
  if (typeof window === "undefined") return;
  if (!window.location.pathname.startsWith(PORTAL_PATH_PREFIX)) return;

  try {
    // index.html captures and strips it before the analytics tags load.
    const w = window as Window & { __NUDGE_PORTAL_ACCESS__?: string };
    if (w.__NUDGE_PORTAL_ACCESS__) {
      capturedToken = w.__NUDGE_PORTAL_ACCESS__;
      w.__NUDGE_PORTAL_ACCESS__ = undefined;
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const token = params.get(ACCESS_PARAM);
    if (!token) return;

    capturedToken = token;
    params.delete(ACCESS_PARAM);

    const query = params.toString();
    const next = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
    // replaceState, not pushState: the token must not survive in history either.
    window.history.replaceState(window.history.state, "", next);
  } catch {
    // Never let this break the page — the worst case is the gate asking for an email.
  }
}

/** The token, if this page load carried one. Consumed once, then forgotten. */
export function takeAccessToken(): string | null {
  const token = capturedToken;
  capturedToken = null;
  return token;
}

// Run on import, before analytics initialise.
captureAndStripAccessToken();
